import React from 'react'
import { Box, Button, Container, Grid, InputLabel, Stack, TextField, Typography, } from "@mui/material";

export default function WhyChoose() {
    return (
        <Grid container justifyContent="center" spacing={0}>
            <Grid item xs={11} md={11} lg={11} ml={2} mr={2} >
                <div>
                    <Box 
                        id="about-us"
                        sx={{
                            backgroundColor: 'rgba(49, 185, 181, 0.1)',
                            padding: { xs: 2, md: 4 },
                            borderRadius: '8px',
                        }}
                    >

                        <Grid container alignItems="center">
                            <Grid
                                item
                                xs={12}
                                md={12}
                                textAlign="center"
                                px={{ xs: 2 }}
                                my={{ xs: 2, md: 4 }}
                            >
                                <Typography mb={2} variant={"h2"}>
                                    {`Why Choose CliQloan?`}
                                </Typography>



                            </Grid>


                            <Grid
                                container
                                spacing={3}
                                alignItems="flex-start" // Align items at the top vertically
                            >


                                <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    textAlign={{ xs: "center", md: "start" }}
                                    px={{ xs: 2 }}  //padding x-axis left


                                >
                                    <Typography


                                        mb={2}
                                        fontWeight={"700"}
                                        size={"16px"}
                                        lineHeight={"19.36px"}
                                        align="center"
                                        sx={{ marginRight: "20px" }}
                                    >
                                        {`100+ Loan Officers`}
                                    </Typography>
                                    <Typography variant="body1" mb={5} align="center">
                                        {` With CliQloan Loan Origination System, With over 100 Loan Officers at your service, CliQloan ensures personalized attention and expertise for every client's unique needs, guaranteeing a smooth and efficient loan origination process. ensuring every borrower receives personalized attention and expedited loan approvals.`}
                                    </Typography>

                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    textAlign={{ xs: "center", md: "start" }}
                                    px={{ xs: 2 }}  //padding x-axis left

                                >
                                    <Typography

                                        sx={{ marginRight: "20px" }}
                                        mb={2}
                                        fontWeight={"700"}
                                        size={"16px"}
                                        lineHeight={"19.36px"}
                                        align="center"
                                    >
                                        {`Time `}
                                    </Typography>
                                    <Typography variant="body1" mb={5} align="center">
                                        {`Experience rapid verification processes with CliQloan, reducing user wait times and accelerating product integration, ensuring swift deployment and immediate access to our innovative loan origination solutions.`}
                                    </Typography>

                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    textAlign={{ xs: "center", md: "start" }}
                                    px={{ xs: 2 }}  //padding x-axis left

                                >
                                    <Typography

                                        sx={{ marginRight: "20px" }}
                                        mb={2}
                                        fontWeight={"700"}
                                        size={"16px"}
                                        lineHeight={"19.36px"}
                                        align="center"
                                    >
                                        {`Instant response/ result `}
                                    </Typography>
                                    <Typography variant="body1" mb={5} align="center">
                                        {`Elevate customer satisfaction with CliQloan's instant customer service feature, providing real-time support to borrowers and loan officers alike, ensuring smooth transactions and reinforcing trust in your lending institution's commitment to exceptional service.`}
                                    </Typography>

                                </Grid>
                            </Grid>
                        </Grid>

                    </Box>

                </div>
            </Grid>
        </Grid>
    )
}
